import Navbar from "../Navbar/navbar";

import Footer from "../Footer/footer";
import { React, useEffect, useState, useMemo, useRef } from "react";

import { motion, AnimatePresence } from "framer-motion";
import { useSwipeable } from "react-swipeable"; // Import swipeable
import { useNavigate } from "react-router-dom";
import icons from "../../icons.config";
import images from "../../images.config";
import { useDispatch, useSelector } from "react-redux";
import { addToFavourites, removeFromFavourites } from "../../Providers/favouritesProvider.js";
import { setClickedItem } from "../../store/itemsSlice";
import { getAllProducts } from "../../Providers/shopProvider.js";
import {
  applyFilters,
  clearFilters,
  selectFilteredItems,
} from "../../store/itemsSlice";
import ReactSlider from "react-slider";
import itemData from "../dressData";
import FooterDoodles from "../Footer/footerDoodles";
import shopApi from "./shopApi";
import { FOUNDER_IMAGE_URL, IMAGE_BASE_URL } from "../../api-urls.js";

// const itemData = [
//   {
//     id: 4,
//     title: "Black all item",
//     price: 1200,
//     discounted_price: 1149,
//     image: [
//       images.collection1,
//       images.collectionVideo2,
//       images.collection2,
//       images.collection1,
//       images.collection2,
//       images.collectionVideo3,
//     ],
//   },
//   {
//     id: 5,
//     title: "keyhole item",
//     price: 1200,
//     discounted_price: 1149,
//     image: [
//       images.collection3,
//       images.collectionVideo3,
//       images.collection1,
//       images.collection1,
//       images.collection3,
//       images.collection1,
//       images.collection1,
//       images.collectionVideo1,
//     ],
//   },
//   {
//     id: 6,
//     title: "keyhole item",
//     price: 1205,
//     discounted_price: 1149,
//     image: [
//       images.collection2,
//       images.collectionVideo4,
//       images.collection1,
//       images.collection1,
//       images.collection3,
//       images.collection1,
//       images.collection1,
//       images.collectionVideo2,
//     ],
//   },
//   {
//     id: 7,
//     title: "keyhole item",
//     price: 1205,
//     discounted_price: 1149,
//     image: [
//       images.collection2,
//       images.collectionVideo3,
//       images.collection1,
//       images.collection1,
//       images.collection3,
//       images.collection1,
//       images.collection1,
//       images.collectionVideo2,
//     ],
//   },
//   {
//     id: 8,
//     title: "keyhole item",
//     price: 1205,
//     discounted_price: 1149,
//     image: [
//       images.collection2,
//       images.collectionVideo2,
//       images.collection1,
//       images.collection1,
//       images.collection3,
//       images.collection1,
//       images.collection1,
//       images.collectionVideo2,
//     ],
//   },
// ];

const imagesResponse = [images.collection3, images.trend1, images.trend2];
// const itemData = [
//   { id: 1, title: "Asymmetric item", price: "Rs. 11,000 INR", image: images.trend1 },
//   { id: 2, title: "Black Keyhole item", price: "Rs. 10,900 INR", image: images.collection2 },
//   { id: 3, title: "Ruffled item", price: "Rs. 11,000 INR", image: images.collection3 },
//   { id: 4, title: "Asymmetric item", price: "Rs. 10,900 INR", image: images.collection1 },
//   { id: 5, title: "Black Keyhole item", price: "Rs. 11,000 INR", image: images.collection2 },
//   { id: 6, title: "Ruffled item", price: "Rs. 10,900 INR", image: images.collection3 },
// ];

// const itemDataC = [
//   { id: 1, title: "Asymmetric item", price: "Rs. 11,000 INR", image: images.collection1 },
//   { id: 2, title: "Black Keyhole item", price: "Rs. 10,900 INR", image: images.collection2 },
//   { id: 3, title: "Ruffled item", price: "Rs. 11,000 INR", image: images.collection3 },
//   { id: 4, title: "Asymmetric item", price: "Rs. 10,900 INR", image: images.collection1 },
//   { id: 5, title: "Black Keyhole item", price: "Rs. 11,000 INR", image: images.collection2 },
//   { id: 6, title: "Ruffled item", price: "Rs. 10,900 INR", image: images.collection3 },
//   { id: 7, title: "Asymmetric item", price: "Rs. 10,900 INR", image: images.collection3 },
//   { id: 8, title: "Black Keyhole item", price: "Rs. 11,000 INR", image: images.collection1 },
//   { id: 9, title: "Ruffled item", price: "Rs. 10,900 INR", image: images.collection2 },
//   { id: 10, title: "Asymmetric item", price: "Rs. 10,900 INR", image: images.collection3 },
//   { id:11, title: "Black Keyhole item", price: "Rs. 11,000 INR", image: images.collection1 },
//   { id: 12, title: "Ruffled item", price: "Rs. 10,900 INR", image: images.collection2 },
// ];
function Shop({ item }) {
  const [itemData, setItemData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleItems, setVisibleItems] = useState(3); // Default for large screens
  const [autoPlay, setAutoPlay] = useState(true); // Auto-animate for smaller screens
  // const [isFading, setIsFading] = useState(false); // Manage fading effect
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    if (!loading) {
      fetchProducts();
      setLoading(false);
    }
  }, [selectedCategory, loading]);
  const fetchProducts = async () => {
    setLoading(true);
    setError(null);

    try {
      let response = await getAllProducts();
      console.log("Full API Response:", response); // Log the response

      if (!response || typeof response !== "object") {
        throw new Error("API response is not an object.");
      }

      if (!("data" in response)) {
        throw new Error("Missing 'data' key in response.");
      }

      console.log("response.data:", response.data); // Log response.data

      if (!Array.isArray(response.data)) {
        throw new Error("'data' key is not an array. Received:", response.data);
      }

      console.log("Valid Data:", response.data);
      setItemData(response.data);
    } catch (err) {
      console.error("Error fetching products:", err);
      setError(err.message || "Error fetching products.");
      setItemData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setVisibleItems(2); // Show 2 items on small and medium screens
        setAutoPlay(true); // Enable autoplay on smaller screens
      } else {
        setVisibleItems(3); // Show 3 items on large screens
        setAutoPlay(false); // Disable autoplay on larger screens
      }
    };

    handleResize(); // Set initial state based on window size
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleNext = () => {
    setIsFading(true); // Start fading effect
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % itemData.length);
      setIsFading(false); // End fading after image swap
    }, 500); // Match fade duration
  };

  const handlePrev = () => {
    setIsFading(true); // Start fading effect
    setTimeout(() => {
      setCurrentIndex(
        (prevIndex) => (prevIndex - 1 + itemData.length) % itemData.length
      );
      setIsFading(false); // End fading after image swap
    }, 500); // Match fade duration
  };

  // Helper function to get visible itemes
  // const getVisibleItems = () => {
  //   console.log("Getting visible items", itemData);
  //   const endIndex = currentIndex + visibleItems;

  //   return itemData
  //     .filter((item) => item.product_category.includes("Trend Waves")) // Correct filtering
  //     .slice(currentIndex, endIndex)
  //     .concat(
  //       itemData.slice(
  //         0,
  //         endIndex > itemData.length ? endIndex - itemData.length : 0
  //       )
  //     );
  // };

  const getVisibleItems = () => {
    console.log("Getting visible items", itemData);

    // Filter out only the "Trend Waves" category items
    const filteredItems = itemData.filter((item) =>
      item.product_category.includes("Trend Waves")
    );
    console.log("Trend waves Filtered items-----", filteredItems);

    // if (filteredItems.length === 0) return []; // Prevents errors if no matching items

    // const endIndex = currentIndex + visibleItems;

    // // Ensure the slice does not repeat the same items
    // let visibleItemsList = filteredItems.slice(currentIndex, endIndex);

    // // Handle wrapping if endIndex exceeds array length
    // if (endIndex > filteredItems.length) {
    //   const extraItemsNeeded = endIndex - filteredItems.length;
    //   visibleItemsList = [
    //     ...visibleItemsList,
    //     ...filteredItems.slice(0, extraItemsNeeded),
    //   ];
    // }

    // console.log("Final visible items:", visibleItemsList);
    // return visibleItemsList;
   return filteredItems;
  };

  // const getVisibleItems = () => {
  //   console.log("Getting visible items", itemData);

  //   // Filter items by category
  //   const filteredItems = itemData;

  //   // const filteredItems = itemData.filter((item) => item.isFastFashion === true);

  //   // Determine the end index for slicing
  //   const endIndex = currentIndex + visibleItems;

  //   // If the number of filtered items is less than visibleItems, return them all
  //   if (filteredItems.length <= visibleItems) {
  //     return filteredItems;
  //   }

  //   // Slice the filtered items array to get the visible items
  //   const visibleItemsArray = filteredItems
  //     .slice(currentIndex, endIndex)
  //     .concat(
  //       filteredItems.slice(
  //         0,
  //         endIndex > filteredItems.length ? endIndex - filteredItems.length : 0
  //       )
  //     );
  //     console.log("Visible items" ,visibleItemsArray);

  //   return visibleItemsArray;
  // };

  // Dots navigation logic
  const numberOfDots = Math.ceil(itemData.length / visibleItems);
  const handleDotClick = (index) => {
    setIsFading(true); // Start fading effect
    setTimeout(() => {
      setCurrentIndex(index * visibleItems);
      setIsFading(false); // End fading after image swap
    }, 500); // Match fade duration
  };

  const handlers = useSwipeable({
    onSwipedLeft: handleNext,
    onSwipedRight: handlePrev,
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  // const handleitemClick = () => {
  //   navigate("/view"); // Navigate to /vire
  // };

  const handleitemClick = (item) => {
    console.log("Item received in handleitemClick:", item); // Debugging

    if (!item || !item.default_variant.id) {
      console.error("Item is undefined or has no id");
      return;
    }

    dispatch(setClickedItem(item));
    navigate(`/view/product/${item.default_variant.id}`); // Dynamically inserting product ID
  };

  const [currentIndexC, setCurrentIndexC] = useState(0);
  const [isFading, setIsFading] = useState(false); // Manage fading effect

  const handleNextC = () => {
    setIsFading(true); // Start fading effect
    setTimeout(() => {
      setIsFading(false); // End fading after image swap
    }, 500); // Match fade duration
  };

  const handlePrevC = () => {
    setIsFading(true); // Start fading effect
    setTimeout(() => {
      setIsFading(false); // End fading after image swap
    }, 500); // Match fade duration
  };

  const handlers1 = useSwipeable({
    onSwipedLeft: handleNextC,
    onSwipedRight: handlePrevC,
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  // const dispatch = useDispatch();
  // const likedItems = useSelector((state) => state.likedItems);

  // const handleHeartClick = (item) => {
  //   const isLiked = likedItems.some((item) => item.id === item.id);
  //   if (isLiked) {
  //     dispatch(removeLikedItem(item)); // Remove the item from liked items
  //   } else {
  //     dispatch(addLikedItem(item)); // Add the item to liked items
  //   }
  // };
  const dispatch = useDispatch();
  const likedItems = useSelector((state) => state.favourites.items || []);
  console.log("liked itemsssssssss===================,",likedItems);

  const handleHeartClick = (item) => {
    if (!item || !item.default_variant) {
      console.error("Error: item or default_variant is undefined", item);
      return;
    }
  
    console.log("heart item-------", item);
    console.log("heart items list-------", likedItems);
  
    // Ensure likedItems is an array, default to empty array if not
    const safeLikedItems = Array.isArray(likedItems) ? likedItems : [];
    
    const isLiked = safeLikedItems.some(
      (likedItem) =>
        likedItem.default_variant?.id === item.default_variant?.id
    );
  
    console.log("is liked data------", isLiked);
  
    if (isLiked) {
      dispatch(removeFromFavourites(item.default_variant.id)); // Remove from favourites
    } else {
      dispatch(addToFavourites(item.default_variant.id)); // Add to favourites
    }
  };


  const appliedFilters = useSelector((state) => state.items.filters); // Access filters from the Redux store
  const filteredItems = useSelector(selectFilteredItems); // Get filtered items from Redux

  const [hoveredId, setHoveredId] = useState(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isPriceOpen, setIsPriceOpen] = useState(true);
  const [isSizeOpen, setIsSizeOpen] = useState(false);

  const [priceFilter, setPriceFilter] = useState({
    min: "5000",
    max: " 40000",
  });

  const toggleFilter = () => setIsFilterOpen(!isFilterOpen);
  const togglePrice = () => setIsPriceOpen(!isPriceOpen);
  const toggleSize = () => setIsSizeOpen(!isSizeOpen);

  // const handlePriceChange = (min, max) => {
  //   dispatch(
  //     applyFilters({
  //       price: { min, max },
  //       sizes: appliedFilters.sizes, // Keep existing size filters
  //     })
  //   );
  // };
  const handlePriceChange = (e) => {
    const { name, value } = e.target;
    setPriceFilter((prev) => ({
      ...prev,
      [name]: parseInt(value),
    }));
  };

  const handleRangeChange = (e) => {
    const { name, value } = e.target;
    setPriceFilter((prev) => ({
      ...prev,
      [name]: parseInt(value),
    }));
  };
  const handleSliderChange = (values) => {
    setPriceFilter({ min: values[0], max: values[1] });
  };

  const handleSizeChange = (size) => {
    // Toggle size in Redux state
    const newSizes = appliedFilters.sizes.includes(size)
      ? appliedFilters.sizes.filter((s) => s !== size)
      : [...appliedFilters.sizes, size];

    dispatch(
      applyFilters({
        price: appliedFilters.price, // Keep existing price filters
        sizes: newSizes, // Update size filter in Redux
      })
    );
  };

  const clearAllFilters = () => {
    setPriceFilter({ min: "", max: "" });
    dispatch(clearFilters()); // Clear both price and size filters in Redux
  };
  const appliedFilterCount =
    (priceFilter.min || priceFilter.max ? 1 : 0) +
    (appliedFilters?.sizes?.length || 0); // Safely access sizes

  // Function to handle removing individual filters (either price or size)
  const handleRemoveFilter = (type, value) => {
    if (type === "price") {
      // Remove price filter
      setPriceFilter({ min: "", max: "" });
      dispatch(
        applyFilters({
          price: { min: "", max: "" }, // Clear the price filter
          sizes: appliedFilters.sizes, // Keep existing size filters
        })
      );
    } else if (type === "size") {
      // Remove size filter
      const updatedSizes = appliedFilters.sizes.filter(
        (size) => size !== value
      );
      dispatch(
        applyFilters({
          price: appliedFilters.price, // Keep existing price filters
          sizes: updatedSizes, // Remove the size filter
        })
      );
    }
  };

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedSort, setSelectedSort] = useState("Sort By");

  const handleSortOptionClick = (option) => {
    setSelectedSort(option);
    setIsDropdownOpen(false);

    // Add sorting logic here based on the selected option
    switch (option) {
      case "Latest":
        console.log("Sort by Latest");
        break;
      case "A to Z":
        console.log("Sort A to Z");
        break;
      case "Z to A":
        console.log("Sort Z to A");
        break;
      case "Price: Low to High":
        console.log("Sort Price: Low to High");
        break;
      case "Price: High to Low":
        console.log("Sort Price: High to Low");
        break;
      case "Date: Old to New":
        console.log("Sort Date: Old to New");
        break;
      case "Date: New to Old":
        console.log("Sort Date: New to Old");
        break;
      default:
        break;
    }
  };
  const [isSortOpen, setIsSortOpen] = useState(false);

  const toggleSort = () => {
    setIsSortOpen((prev) => !prev);
  };

  const filteredData = useMemo(() => {
    if (!itemData || itemData.length === 0) return []; // Handle empty or undefined data

    console.log("Applying Filters:", priceFilter, appliedFilters.sizes); // Debug the filter conditions

    // If no filters are applied, return all data
    if (
      !priceFilter.min &&
      !priceFilter.max &&
      appliedFilters.sizes.length === 0
    ) {
      console.log("No filters applied. Returning all data.");
      return itemData;
    }

    // Apply filters (price range, sizes)
    return itemData
      .filter((item) => {
        const isWithinPrice =
          (!priceFilter.min || item.price >= priceFilter.min) &&
          (!priceFilter.max || item.price <= priceFilter.max);
        console.log("isWithinPrice:", isWithinPrice, "for item:", item); // Check price condition

        const matchesSize =
          appliedFilters.sizes.length === 0 ||
          appliedFilters.sizes.some((size) =>
            item.sizes.some(
              (itemSize) =>
                itemSize.trim().toLowerCase() === size.trim().toLowerCase()
            )
          );
        console.log("matchesSize:", matchesSize, "for item:", item); // Check size condition

        return isWithinPrice && matchesSize;
      })
      .sort((a, b) => {
        // Sorting logic
        if (selectedSort === "Price: Low to High") return a.price - b.price;
        if (selectedSort === "Price: High to Low") return b.price - a.price;
        if (selectedSort === "Newest")
          return new Date(b.dateAdded) - new Date(a.dateAdded);
        if (selectedSort === "Oldest")
          return new Date(a.dateAdded) - new Date(b.dateAdded);
        return 0; // Default sorting
      });
  }, [itemData, priceFilter, appliedFilters, selectedSort]);
  console.log("filtered data item", filteredData);

  const [displayedItems, setDisplayedItems] = useState([]); // Items currently displayed
  const [currentPage, setCurrentPage] = useState(1); // Current pagination page
  const itemsPerPage = 5; // Number of items per batch
  const [hasMore, setHasMore] = useState(true); // Flag for more data
  const [isLoading, setIsLoading] = useState(false); // Loader state
  const loaderTimeout = 1000; // Simulated loading time in milliseconds
  const observerRef = useRef();

  // Initial load of items
  useEffect(() => {
    const initialItems = filteredData.slice(0, itemsPerPage);
    setDisplayedItems(initialItems);
  }, [filteredData]);

  // Handle Scroll Event
  useEffect(() => {
    // const handleScroll = () => {
    //   // Check if user has scrolled to the bottom
    //   if (
    //     window.innerHeight + document.documentElement.scrollTop >=
    //     document.documentElement.offsetHeight - 10 &&
    //     !isLoading
    //   ) {
    //     loadMoreItems();
    //   }
    // };
    const handleScroll = () => {
      const visibleElements = document.querySelectorAll(".grid > div"); // Select all grid children
      if (!isLoading && visibleElements.length > 0) {
        const lastElement = visibleElements[visibleElements.length - 1];
        const lastElementRect = lastElement.getBoundingClientRect();

        // Check if 50% of the last element is visible
        if (
          lastElementRect.top <=
          window.innerHeight - lastElementRect.height / 2
        ) {
          loadMoreItems();
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [displayedItems, isLoading]);

  // Load more items on scroll
  const loadMoreItems = () => {
    setIsLoading(true); // Start loader
    const nextPage = currentPage + 1;
    const startIndex = currentPage * itemsPerPage;
    const newItems = filteredData.slice(startIndex, startIndex + itemsPerPage);

    setTimeout(() => {
      if (newItems.length === 0) {
        setHasMore(false); // No more items to load
      } else {
        setDisplayedItems((prevItems) => [...prevItems, ...newItems]);
        setCurrentPage(nextPage);
      }
      setIsLoading(false); // Stop loader
    }, loaderTimeout); // Simulate loading time
  };
  const [gridType, setGridType] = useState("double"); // Default to double-column layout
  const [gridIcon, setGridIcon] = useState({
    enlarge: icons.viewEnlargeLight,
    small: icons.viewSmallLight,
  }); // Default icons

  // Handle icon and grid type toggle
  const handleGridToggle = (type) => {
    if (type === "single") {
      setGridType("single");
      setGridIcon({
        enlarge: icons.viewEnlarge,
        small: icons.viewSmallLight,
      });
    } else {
      setGridType("double");
      setGridIcon({
        enlarge: icons.viewEnlargeLight,
        small: icons.viewSmall,
      });
    }
  };

  return (
    <div className="overflow-hidden">
      <Navbar />
      <section className="flex flex-col justify-center items-center w-full h-full bg-tertiary pt-60 lg:pt-5 relative pb-0  space-y-5 overflow-hidden">
        <div className="hidden lg:block relative lg:left-[45%]  z-10">
          <img src={icons.trendCircles} alt="Doodle Left" className="w-[70%]" />
        </div>
      </section>
      <section className="">
        <div className="flex flex-col justify-center items-center w-full h-full bg-tertiary  relative pb-10 space-y-5  -mt-36">
          <h1 className="text-primary1 font-poppins text-3xl lg:py-14 font-extralight mb-2 relative bottom-2">
            TREND WAVES
          </h1>

          <div
            className="relative w-full max-w-7xl h-full  bottom-2 "
            {...handlers}
          >
            {/* Hide buttons on smaller screens */}
            <img
              src={icons.arrowLeft}
              alt="left arrow"
              className="absolute lg:left-20 xl:left-11 2xl:-left-1 top-[45%] transform -translate-y-1/2 text-primary1 text-lg font-semibold w-8 h-8 rounded-[50%] z-20 bg-secondary hidden lg:block"
              onClick={handlePrev}
            />

            <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10 lg:gap-6 px-11 md:px-11 lg:px-24 xl:px-14 2xl:px-2  ">
              {getVisibleItems().map((item) => {
                console.log("visible itemss-------",item);
                return (
                  <div
                    key={item.id}
                    className="text-left flex justify-center relative z-10"
                  >
                    <AnimatePresence mode="wait">
                      <motion.div
                        key={item.id}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        transition={{ duration: 0.5 }}
                        className={` ${
                          isFading ? "opacity-0" : "opacity-100"
                        } cursor-pointer`}
                        onMouseEnter={() => item.default_variant && setHoveredId(item.default_variant.id)}

                        onMouseLeave={() => setHoveredId(null)} // Reset hover state
                      >
                        {/* item Image or Video */}
                        {/*
                        {hoveredId === item.id ? (
                          <motion.video
                            src={item.images[1]} // Replace with your video path
                            className="w-full h-[85%] md:h-[90%] md:w-[100%] object-cover mb-4"
                            autoPlay
                            muted
                            loop
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.5 }}
                            onClick={() => handleitemClick(item)}
                          />
                        ) : (
                      */}
                        <motion.img
                          src={
                            FOUNDER_IMAGE_URL + item.default_variant.images[0]
                          }
                          alt={item.product_name}
                          className="w-full h-[85%] md:h-[90%] md:w-[100%] object-cover mb-4"
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          transition={{ duration: 0.5 }}
                          onClick={() => handleitemClick(item)}
                        />
                        {/* )} */}

                        {/* Heart Icon */}
                        <div
                          className="absolute top-4 right-4 text-primary1 font-light cursor-pointer"
                          onClick={() => handleHeartClick(item)} // Toggle like/unlike
                        >
                          <img
                            src={
                              likedItems.some(
                                (likedItem) =>
                                  likedItem.default_variant && item.default_variant &&
                                  likedItem.default_variant.id === item.default_variant.id
                              )
                              
                              
                                ? icons.filledHeart
                                : icons.heart
                            }
                            alt="Heart Icon"
                            className="w-5 h-5 md:w-7 md:h-7"
                          />
                        </div>

                        {/* Title */}
                        <motion.h2
                          className="font-light mt-2 font-outfit text-lg text-primary1"
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 0 }}
                          transition={{ duration: 0.5 }}
                        >
                          {item.product_name}
                        </motion.h2>

                        {/* Description */}
                        <motion.p
                          className="text-sm mt-1 text-hcolor font-poppins font-light"
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 0 }}
                          transition={{ duration: 0.5 }}
                        >
                          {item.default_variant.discount_price}
                        </motion.p>
                      </motion.div>
                    </AnimatePresence>
                  </div>
                );
              })}
            </div>

            <img
              src={icons.arrowRight}
              alt="right arrow"
              className="absolute top-[45%] lg:right-20 xl:right-10 2xl:-right-2 transform -translate-y-1/2  hidden text-primary1 rounded-[50%] bg-secondary  lg:block w-8 h-8 z-10"
              onClick={handleNext}
            />
          </div>
          <div className="flex justify-center relative -bottom-2 z-10 lg:hidden py-5">
            {Array.from({ length: numberOfDots }).map((_, dotIndex) => (
              <button
                key={dotIndex}
                onClick={() => handleDotClick(dotIndex)}
                className={`w-2 h-2 md:h-3 md:w-3 mx-2 rounded-full 
     ${
       dotIndex === Math.floor(currentIndex / visibleItems)
         ? "bg-hcolor"
         : "bg-white border border-hcolor"
     } 
     shadow-lg`}
              />
            ))}
          </div>

          <div className="lg:hidden z-30">
            {/* <div className="absolute left-0 top-20 z-0">
       <img src={icons.collectionMCircle} alt="Doodle Left" className="w-full " />
     </div> */}
            <div className="absolute left-6 -bottom-5 ">
              <img
                src={icons.collectionMFlower}
                alt="Doodle Right"
                className="w-12 md:w-full "
              />
            </div>
          </div>

          {/* <div className='flex justify-center mt-2 pt-2 relative bottom-10 pb-1'>
     <button className='border-2 py-2 px-4 flex text-hcolor font-outfit font-medium hover:bg-hcolor hover:text-primary2 transition-all duration-500 ease-in-out'>
       VIEW ALL
     </button>
   </div> */}
        </div>
      </section>
      <section className="bg-tertiary relative py-2 lg:py-0 ">
        <div>
          {/* Filters Section */}
          {isFilterOpen && (
            <div
              className={`fixed top-0 left-0 h-full w-[80%] bg-tertiary p-5 z-50 transform transition-transform duration-300 ease-in-out 
            ${isFilterOpen ? "translate-x-0" : "-translate-x-full"}
            lg:absolute lg:translate-x-0 lg:w-[25%] lg:h-full 
            ${isFilterOpen ? "lg:left-28 lg:top-20" : "lg:left-20 lg:top-28"}
          `}
            >
              <div
                className="flex items-center mb-4 cursor-pointer"
                onClick={toggleFilter}
              >
                <img
                  src={icons.Filter}
                  alt="filter icon"
                  className="mr-2 h-6 w-6 lg:h-7 lg:w-7"
                />{" "}
                {/* Adjust spacing with margin-right */}
                <h2 className="font-outfit font-light text-xl md:text-2xl">
                  Filters ({appliedFilterCount})
                </h2>
                <img
                  src={icons.close} // Replace with your cross icon path
                  alt="close"
                  className="absolute top-5 lg:top-7 right-3 lg:right-5 h-7 w-7 cursor-pointer"
                  onClick={toggleSort} // Close the slider
                />
                {/* <p className="text-4xl font-outfit font-bold "> ({appliedFilterCount})</p> */}
              </div>

              {/* Applied Filters */}
              {appliedFilterCount > 0 && (
                <div className="mb-6">
                  <h3 className="font-normal font-oufit text-lg mb-2">
                    Applied Filters
                  </h3>
                  <div className="flex flex-wrap gap-4">
                    {priceFilter.min && priceFilter.max && (
                      <span className="text-md bg-primary2 text-hcolor px-3 py-1 flex justify-between ">
                        Rs.{priceFilter.min} - Rs.{priceFilter.max}
                        <img
                          src={icons.closeFilter}
                          alt="close"
                          className="relative left-2 cursor-pointer"
                          onClick={() => handleRemoveFilter("price")} // Remove price filter
                        />
                      </span>
                    )}
                    {appliedFilters.sizes.map((size) => (
                      <span
                        key={size}
                        className="text-md px-3 bg-primary2 text-hcolor py-1 flex justify-between"
                      >
                        {size}
                        <img
                          src={icons.closeFilter}
                          alt="close"
                          className="relative left-2 cursor-pointer"
                          onClick={() => handleRemoveFilter("size", size)} // Remove individual size filter
                        />
                      </span>
                    ))}
                    {/* Clear Filters Button */}
                  </div>
                  <button
                    className="text-hcolor font-outfit font-normal mt-2 underline"
                    onClick={clearAllFilters} // Clear all filters
                  >
                    Clear All
                  </button>
                </div>
              )}

              {/* Price Filter */}
              <div>
                <div
                  className="flex justify-between items-center cursor-pointer"
                  onClick={togglePrice}
                >
                  <h3 className="font-normal font-outfit">Price</h3>

                  <img
                    src={icons.dropdown}
                    alt="dorpdown"
                    className={`transform transition-transform ${
                      isPriceOpen ? "-rotate-90" : ""
                    }`}
                  />
                </div>
                {isPriceOpen && (
                  <div className="mt-3 space-y-3">
                    {/* Display Selected Range */}

                    <div className="flex justify-stretch ">
                      <div>
                        <span className="text-lg">Rs. </span>
                        <input
                          type="number"
                          name="min"
                          value={priceFilter.min}
                          onChange={(e) =>
                            setPriceFilter((prev) => ({
                              ...prev,
                              min: parseInt(e.target.value),
                            }))
                          }
                          className="border-2 border-primary1 px-3 py-2 text-hcolor font-medium w-1/2  appearance-none"
                        />
                      </div>
                      <div>
                        <span className="text-lg">Rs. </span>
                        <input
                          type="number"
                          name="max"
                          value={priceFilter.max}
                          onChange={(e) =>
                            setPriceFilter((prev) => ({
                              ...prev,
                              max: parseInt(e.target.value),
                            }))
                          }
                          className="border-2 border-primary1 px-3 py-2 text-hcolor font-medium  w-1/2  appearance-none"
                        />
                      </div>
                    </div>
                    {/* Custom Slider with two handles */}
                    <div className="flex items-center">
                      <ReactSlider
                        className="w-full"
                        value={[priceFilter.min, priceFilter.max]}
                        onChange={handleSliderChange}
                        min={5000}
                        max={40000} // Set max value as needed
                        step={1}
                        renderTrack={(props, state) => {
                          const { index } = state;
                          return (
                            <div
                              {...props}
                              style={{
                                ...props.style,
                                height: "4px",
                                background:
                                  index === 0
                                    ? "#ddd" // Before the range
                                    : index === 1
                                    ? "#650D1B" // Within the range
                                    : "#ddd", // After the range
                              }}
                            />
                          );
                        }}
                        renderThumb={(props) => (
                          <div
                            {...props}
                            style={{
                              ...props.style,
                              height: "15px",
                              width: "15px",
                              borderRadius: "50%",
                              background: "#650D1B",
                              transform: "translate(-5px, -5px)", // Shifting thumb by -2px
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* Size Filter */}
              <div className="mt-6">
                <div
                  className="flex justify-between items-center cursor-pointer"
                  onClick={toggleSize}
                >
                  <h3 className="font-normal font-outfit">Size</h3>
                  {/* <span
                className={`transform transition-transform ${isSizeOpen ? "rotate-180" : ""}`}
              >
                ▼
              </span> */}
                  <img
                    src={icons.dropdown}
                    alt="dorpdown"
                    className={`transform transition-transform ${
                      isSizeOpen ? "-rotate-90" : ""
                    }`}
                  />
                </div>
                {isSizeOpen && (
                  <div className="mt-3 space-y-2">
                    {[
                      "XXS/4",
                      "XS/6",
                      "S/8",
                      "M/10",
                      "L/14",
                      "XL/16",
                      "XXL/18",
                    ].map((size) => (
                      <div key={size} className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          id={size}
                          className="cursor-pointer accent-primary1"
                          checked={appliedFilters.sizes.includes(size)}
                          onChange={() => handleSizeChange(size)} // Update size in Redux
                        />
                        <label
                          htmlFor={size}
                          className="cursor-pointer text-gray-700"
                        >
                          {size}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {/* Sort By Filter */}
              <div className="lg:hidden mt-6">
                <div
                  className="flex justify-between items-center cursor-pointer"
                  onClick={toggleSort}
                >
                  <h3 className="font-normal font-outfit">Sort By</h3>
                  <img
                    src={icons.dropdown}
                    alt="dropdown"
                    className={`transform transition-transform ${
                      isSortOpen ? "-rotate-180" : ""
                    }`}
                  />
                </div>
                {isSortOpen && (
                  <div className="mt-3 space-y-2">
                    {[
                      "Price: Low to High",
                      "Price: High to Low",
                      "Newest",
                      "Oldest",
                    ].map((option) => (
                      <div key={option} className="flex items-center gap-2">
                        {/* <input
                            type="radio"
                            id={option}
                            name="sort"
                            className="cursor-pointer accent-primary1"
                            onChange={() => handleSortOptionClick(option)} // Handle sort change
                          /> */}
                        <input
                          type="checkbox"
                          id={option}
                          className="cursor-pointer accent-primary1"
                          onChange={() => handleSortOptionClick(option)} // Update size in Redux
                        />
                        <label
                          htmlFor={option}
                          className="cursor-pointer text-primary1 font-outfit font-light text-lg"
                        >
                          {option}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="mt-6 lg:hidden">
                <button className="border-2  text-hcolor hover:text-tertiary hover:bg-hcolor text-center py-2 w-[96%]  wrap ">
                  Apply Filters
                </button>
              </div>
            </div>
          )}
        </div>

        {/* <div className='w-full h-full bg-tertiary pt-20 pb-0 relative space-y-5 overflow-hidden'> */}
        <div className="">
          <div className="hidden lg:block relative left-[5%] bottom-16 justify-start items-start ">
            <img
              src={icons.collectionFlower}
              alt="Doodle Left"
              className="lg:w-24"
            />
          </div>
          <h1 className="flex text-primary1 font-poppins text-3xl lg:py-4 mt-2 font-extralight mb-5 relative text-center justify-center bottom-1 lg:bottom-20 ">
            OUR COLLECTIONS
          </h1>

          <div className="flex flex-col justify-center items-center">
            <div
              className={`relative ${
                isFilterOpen
                  ? "left-0"
                  : "right-[29%] md:right-[38%] lg:right-[37%] xl:right-[38%]"
              } 
              ${isFilterOpen ? "bottom-20" : "-bottom-4 lg:bottom-20"} 
              flex items-center transition-all duration-300 ease-in-out`}
              onClick={toggleFilter}
            >
              {/* When filter is open, hide the icon and heading */}
              {isFilterOpen ? null : (
                <>
                  <img
                    src={icons.Filter}
                    alt="filter icon"
                    className="mr-2 h-6 w-6 lg:h-7 lg:w-7"
                  />
                  <h2 className="font-outfit font-light text-xl md:text-2xl cursor-pointer">
                    Filters
                  </h2>
                </>
              )}
            </div>
            <div
              className={`hidden lg:flex relative 
      ${isDropdownOpen ? "bottom-28" : "bottom-28"} 
      xl:left-[38%] left-[35%] items-center`}
            >
              <h2 className="font-outfit font-light text-2xl">
                {selectedSort}
              </h2>
              <img
                src={icons.Expand_down}
                alt="down arrow"
                className={`mr-2 cursor-pointer ${
                  isDropdownOpen ? "bottom-28" : "bottom-28"
                } `}
                onClick={() => setIsDropdownOpen((prev) => !prev)}
              />

              {isDropdownOpen && (
                <div
                  className="absolute top-full  bg-tertiary right-2 rounded-md p-2 z-40"
                  style={{ height: "400px", width: "250px" }}
                >
                  {[
                    "Latest",
                    "A to Z",
                    "Z to A",
                    "Price: Low to High",
                    "Price: High to Low",
                    "Date: Old to New",
                    "Date: New to Old",
                  ].map((option) => (
                    <div
                      key={option}
                      className="cursor-pointer text-primary1 font-outfit font-light text-lg mt-1"
                      onClick={() => handleSortOptionClick(option)}
                    >
                      {option}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="lg:hidden relative left-[30%] md:left-[39%] bottom-2 flex items-center">
              <img
                src={gridIcon.enlarge}
                alt="enlarge view"
                className="mr-2 w-6 h-6 cursor-pointer"
                onClick={() => handleGridToggle("single")} // Set to single column
              />
            </div>
            <div className="lg:hidden relative left-[38%] md:left-[44%] bottom-9 pt-1 flex items-center">
              <img
                src={gridIcon.small}
                alt="small view"
                className="mr-2 w-6 h-6 cursor-pointer"
                onClick={() => handleGridToggle("double")} // Set to double column
              />
            </div>

            <div
              className={`flex-grow transition-all duration-300 ${
                isFilterOpen
                  ? "w-full lg:w-[75%] lg:relative lg:-top-0 lg:px-28 lg:ml-auto"
                  : "w-full"
              } bg-tertiary relative max-w-7xl h-full`}
              {...handlers1}
            >
              {filteredData.length > 0 ? (
                (console.log("filtered data-------", displayedItems),
                (
                  <>
                    <div
                      className={`grid ${
                        gridType === "single"
                          ? "grid-cols-1 gap-3"
                          : "grid-cols-2"
                      } lg:grid-cols-3 gap-6 md:gap-10 lg:gap-6 px-11 md:px-11 lg:px-20 xl:px-14 2xl:px-3`}
                    >
                      {displayedItems.map((item) => {
                        return (
                          <div
                            key={item.id}
                            className={`text-left flex justify-center relative z-10 ${
                              gridType === "single" ? "mb-1" : "mb-12"
                            }`}
                          >
                            <AnimatePresence mode="wait">
                              <motion.div
                                key={item.default_variant.id}
                                initial="initial"
                                animate="animate"
                                exit="exit"
                                transition={{ duration: 0.5 }}
                                className={`cursor-pointer`}
                                onMouseEnter={() => item.default_variant && setHoveredId(item.default_variant.id)}

                                onMouseLeave={() => setHoveredId(null)} // Reset when mouse leaves
                              >
                                {/* Image Section */}
                                <motion.div
                                  className="w-full h-[85%] md:h-[90%] flex justify-center items-center overflow-hidden"
                                  initial={{ opacity: 0 }}
                                  animate={{ opacity: 1 }}
                                  exit={{ opacity: 0 }}
                                  transition={{ duration: 0.5 }}
                                  onClick={() => handleitemClick(item)}
                                >
                                  {hoveredId === item.default_variant.id &&
                                  item.default_variant?.images?.length > 2 ? (
                                    <motion.img
                                      src={
                                        FOUNDER_IMAGE_URL +
                                        item.default_variant.images[2]
                                      }
                                      alt={item.product_name || "Product Image"}
                                      className="w-full h-full object-cover transition-all duration-500"
                                    />
                                  ) : item.default_variant?.images?.length >
                                    0 ? (
                                    <motion.img
                                      src={
                                        FOUNDER_IMAGE_URL +
                                        item.default_variant.images[0]
                                      }
                                      alt={
                                        item.product_name || "Product Thumbnail"
                                      }
                                      className="w-full h-full object-cover transition-all duration-500"
                                    />
                                  ) : (
                                    <div className="w-full h-full bg-gray-200 text-gray-500 flex justify-center items-center">
                                      No Image Available
                                    </div>
                                  )}
                                </motion.div>

                                {/* Heart Icon */}
                                <div
                                  className="absolute top-4 right-4 text-primary1 font-light cursor-pointer"
                                  onClick={() => handleHeartClick(item)}
                                >
                                  <img
                                    src={
                                      likedItems.some(
                                        (likedItem) =>
                                          likedItem.default_variant && item.default_variant &&
                                          likedItem.default_variant.id === item.default_variant.id
                                      )
                                      
                                        ? icons.filledHeart
                                        : icons.heart
                                    }
                                    alt="Heart Icon"
                                    className="w-5 h-5 md:w-7 md:h-7"
                                  />
                                </div>

                                {/* Product Name */}
                                {item.product_name && (
                                  <motion.h2
                                    className="font-light mt-2 font-outfit text-md lg:text-lg text-primary1"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 1.5 }}
                                  >
                                    {item.product_name}
                                  </motion.h2>
                                )}

                                {/* Price */}

                                <motion.p
                                  className="text-sm mt-1 text-hcolor font-poppins font-light"
                                  initial={{ opacity: 0 }}
                                  animate={{ opacity: 1 }}
                                  exit={{ opacity: 0 }}
                                  transition={{ duration: 1.5 }}
                                >
                                  {item.default_variant.discount_price}
                                </motion.p>
                              </motion.div>
                            </AnimatePresence>
                          </div>
                        );
                      })}
                    </div>
                  </>
                ))
              ) : (
                <div className="flex justify-center items-center h-full">
                  <p className="text-lg font-medium text-hcolor py-20">
                    No data available for your desired filters.
                  </p>
                </div>
              )}
            </div>

            {/* Dots navigation */}
            <div className="flex justify-center pt-8 z-50 lg:hidden">
              {Array.from({ length: Math.ceil(itemData.length / 3) }).map(
                (_, dotIndex) => (
                  <button
                    key={dotIndex}
                    onClick={() => setCurrentIndex(dotIndex * 3)}
                    className={`w-2 h-2 md:h-3 md:w-3 mx-2 rounded-full shadow-lg 
                ${
                  dotIndex === Math.floor(currentIndex / 3)
                    ? "bg-hcolor"
                    : "bg-white border border-hcolor"
                }`}
                  />
                )
              )}
            </div>

            <div className="lg:hidden">
              <div className="absolute left-0 top-24 z-0">
                <img
                  src={icons.collectionMCircle}
                  alt="Doodle Left"
                  className="w-full"
                />
              </div>
              <div className="absolute right-6 bottom-16">
                <img
                  src={icons.collectionMFlower}
                  alt="Doodle Right"
                  className="w-full"
                />
              </div>
            </div>

            <div className="hidden lg:block absolute md:-right-0 xl:right-16 bottom-0">
              <img
                src={icons.collectionFlower}
                alt="Doodle Left"
                className="lg:w-3/4"
              />
            </div>
          </div>
        </div>
      </section>
      <FooterDoodles />

      <Footer />
    </div>
  );
}

export default Shop;
